import { FormattedNumber } from 'i18n'
import Button from '@components/Button'
import { isExternalUrl } from 'shared/utils'

function BuyButton({ opngo, rate, externalSeasonTicketUrl, buyLabel, bookingUrl }) {
    const buttonProps = () => {
        if (opngo) {
            return {
                href: `https://www.opngo.com${opngo}`,
                target: '_blank',
                iconRight: 'opngo',
                children: <T>{buyLabel}</T>,
                external: true,
            }
        }

        if (externalSeasonTicketUrl) {
            return {
                href: externalSeasonTicketUrl,
                target: '_blank',
                iconRight: 'external',
                children: <T>map.results.list.book.external</T>,
                external: true,
            }
        }

        return {
            href: bookingUrl,
            external: isExternalUrl(bookingUrl),
            children: (
                <>
                    <T>{buyLabel}</T>
                    {rate && (
                        <span className="text-small">
                            <FormattedNumber
                                value={rate.amount}
                                style={'currency'}
                                currency={rate.currency}
                                minimumFractionDigits={rate.fractionDigits}
                                maximumFractionDigits={rate.fractionDigits}
                            />
                        </span>
                    )}
                </>
            ),
        }
    }

    return <Button size="large" block {...buttonProps()} />
}

export default BuyButton
